module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/june-1073576682f2c5665cdd136cb9b6fded.png";